import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { SelectedUsersService } from '../services/selected-users.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { NewUserMessageInformation } from '../models/new-user-message-information.model';
import { UserAlertSummary } from '../models/user-alert-summary.model';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-message-users',
  templateUrl: './message-users.component.html',
  styles: [

  ]
})
export class MessageUsersComponent implements OnInit {

  @ViewChild(NgForm) messageForm: NgForm;
  @ViewChild('editor', { static: false }) editorComponent: CKEditorComponent;

  submitAttempt: boolean = false;
  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: ['heading', '|',
        'bold', 'italic', '|',
        'link', '|',
        'outdent', 'indent', '|',
        'bulletedList', 'numberedList', '|',
        'insertTable', '|',
        /*'imageUpload',*/ 'blockQuote', '|',
        'undo', 'redo'
      ]
    }
  };
  newMessage: NewUserMessageInformation = new NewUserMessageInformation();

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal,
    private selectedUserService: SelectedUsersService,
    private notifier: NotifierService) { }

  ngOnInit(): void {
  }

  clearList(): void {
    this.selectedUserService.Clear();
    this.modal.dismiss();
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  save(): void {
    this.submitAttempt = true;
    if (this.messageForm.form.invalid) {
      return;
    }

    this.newMessage.users = this.selectedUserService.List().map(x => x.userId);

    this.ajax.MakeCall('/Notification/Create', this.newMessage).then(() => {
      this.selectedUserService.Clear();
      this.notifier.notify('success', 'Your message has been sent.');
      this.modal.close();
    }, () => { });
  }

  userCount(): number {
    return this.selectedUserService.Count();
  }

  userList(): readonly UserAlertSummary[] {
    return this.selectedUserService.List();
  }

  removeUser(userId: string): void {
    this.selectedUserService.RemoveUser(userId);
  }
}
